import ServiceReservationDetails from 'components/Content/Happening/ReservationDetails/ServiceDetails/ServiceDetails';
import { withHappeningDetailsProps } from 'viewModel/happening/withHappeningDetailsProps';
import { withEnsureUserIsSignedIn } from 'hocs/withEnsureUserIsSignedIn';

export default withEnsureUserIsSignedIn(withHappeningDetailsProps(ServiceReservationDetails));
